import classnames from 'classnames';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
	addToBasketEvent,
	gotProductsInBasket,
} from '../../../actions/lister-actions';
import { checkBasket } from '../../../utilities/basket-utilities';
import { addToBasket, updateBasket } from '../../../utilities/lister-utilities';
import BasketSnackbar from '../../Snackbar/BasketSnackbar';
import AddToBasketLoadingSpinner from './AddToBasketLoadingSpinner';
import TRANSLATIONS from './translations@default.json';

export const AddToBasketButton = ({
	classes,
	BuyButtonModel: { ProductCode } = {},
	AddToBasketTimeStamp,
	AddToBasketHashToken,
	CategoryId,
}) => {
	const { timeStamps, productsInBasket, isDealsPage } = useSelector(
		(state) => state
	);
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const { PerProductAddToBasketTimeStampHashEnabled } = useSelector(
		(state) => state.featureSwitches
	)

	const productIsInTheBasket = productsInBasket?.list?.includes(ProductCode);

	const [addedToBasket, setAddedToBasket] = useState(productIsInTheBasket);
	const [loading, setLoading] = useState(false);

	const dispatch = useDispatch();

	const handleAddToBasket = () => {
		const amountOfProductsInBasket = productsInBasket?.number;

		setLoading(true);

		if (PerProductAddToBasketTimeStampHashEnabled) {
			timeStamps.addToBasketTimeStamp = AddToBasketTimeStamp;
			timeStamps.addToBasketTimeStampHash = AddToBasketHashToken;
		}

		addToBasket(ProductCode, timeStamps)
			.then((response) => {
				updateBasket(response.TotalNumberOfItems);
				setLoading(false);
				setAddedToBasket(true);
				dispatch(gotProductsInBasket(checkBasket()));

				if (amountOfProductsInBasket > 0) {
					dispatch(addToBasketEvent('listerAddToBasket', ProductCode));
				} else {
					dispatch(
						addToBasketEvent('listerAddToBasketInitialProduct', ProductCode)
					);
				}

				toast(<BasketSnackbar />, { toastId: 'snackbar' });
			})
			.catch(function (error) {
				throw new Error(error);
			});
	};

	// CategoryId 230 is for add on care products, e.g. hob cleaner
	if (!ProductCode || CategoryId === 230) {
		return null;
	}

	if (addedToBasket) {
		return (
			<a
				href={`${window.checkoutUrlPrefix}/shoppingbasket.aspx`}
				className={classnames(
					classes,
					'block cta cta-inactive btn btn-inactive cursor-pointer text-center',
					{
						'z-20': isDealsPage,
						'z-20 ml-2 w-full flex': CustomCategoriesEnabled,
					}
				)}
				data-tag-name="go-to-basket-button-mobile"
				data-testid="go-to-basket-button">
				{TRANSLATIONS.goToBasketButton}
			</a>
		);
	}

	return (
		<button
			type="button"
			className={classnames(classes, 'cta btn btn-primary text-center w-full', {
				'z-20': isDealsPage,
				'z-20 w-full ml-2': CustomCategoriesEnabled,
			})}
			onClick={handleAddToBasket}
			data-testid="add-to-basket-button">
			{loading ? <AddToBasketLoadingSpinner /> : TRANSLATIONS.addToBasketButton}
		</button>
	);
};

export default AddToBasketButton;
